module.exports = __webpack_public_path__ + "images/file_icons_v2/js-8c8f5a183e4000a378f0e299a90de0b0.svg";